import React from 'react'
import Cards from './Cards'
import './Hcategories.css'
const Hcategories = () => {
  return (
    <div className='h_main'>
      <div className="title d-flex justify-content-center align-items-center">
        <h2 className=''>CATEGORIES</h2>
      </div>
      <Cards />
    </div>
  )
}

export default Hcategories